export default __webpack_public_path__ + "static/media/github.1be3365d.svg";